<div class="update-overlay" role="status" aria-live="polite" data-testid="update-overlay">
  <div class="update-overlay__content">
    <div class="update-overlay__logo">
      <img [src]="'logos/checkpoint-icon.png' | envPrefix:'brand'" alt="CheckPoint" class="update-overlay__logo-img" />
    </div>
    <h1 class="update-overlay__title">CheckPoint</h1>
    <div class="update-overlay__status">
      <app-icon name="loader" class="update-overlay__spinner" [size]="16" />
      <span data-testid="update-overlay-message">{{ 'liveUpdate.restarting' | translate }}</span>
    </div>
  </div>
</div>
